import React from 'react'

interface UnsavedChangesAlertProps {
    show: boolean
    submitting: boolean
    onSubmit: () => void
}

const UnsavedChangesAlert: React.FC<UnsavedChangesAlertProps> = ({ show, submitting, onSubmit }) => {
    if (!show) return null

    return (
        <div className="d-flex flex-row">
            <div className="alert alert-warning m-0 p-1 mr-1">
                <i className="fa fa-warning mr-1"></i>
                Modifications non sauvegardées
            </div>
            <button type="submit" className="btn btn-primary m-0 p-1" onClick={onSubmit}>
                {submitting && <i className='fa fa-spinner fa-spin fa-fw mr-1'></i>}
                Valider
            </button>
        </div>
    )
}

export default UnsavedChangesAlert
